import { Injectable } from '@angular/core';
import { AuthService, SiteContext, SiteContextConfig } from '@spartacus/core';
import { CookieService } from 'ngx-cookie';
import { BehaviorSubject, Observable, iif, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { getContextParameterDefault, getContextParameterValues } from 'src/app/core/site-context/context-config-utils';
import { B2bUserService } from '../b2buser/b2b-user.service';
import { ComponentService } from '../component.service';
import { MyAccountPermissionService } from '../myaccount/my-account-permission.service';

@Injectable({
  providedIn: 'root',
})
export class ShimanoBusinessTypeService implements SiteContext<string> {
  private activeBusinessType: BehaviorSubject<string>;

  constructor(
    private config: SiteContextConfig,
    private authService: AuthService,
    private b2bUserService: B2bUserService,
    private myAccountPermissionService: MyAccountPermissionService,
    protected cookieService: CookieService,
    protected componentService: ComponentService
  ) {
    this.activeBusinessType = new BehaviorSubject<string>(this.initBusinessType);
  }

  getActive(): Observable<string> {
    return this.activeBusinessType;
  }

  getAll(): Observable<string[]> {
    return of(getContextParameterValues(this.config, 'shimanoBusinessType'));
  }

  setActive(businessType: string): any {
    this.authService
      .isUserLoggedIn()
      .pipe(
        switchMap((isUserLoggedIn) => iif(() => isUserLoggedIn, this.b2bUserService.getB2bUserProfile(), of(null))),
        map((user) => {
          let userBusinessType: string;
          if (user && user.uid && user.uid !== 'anonymous') {
            //start get user For Recently Viewed
            const recentlyViewedUserID = user.uid.split(':').join('_');
            this.componentService.recentlyViewedUserID$.next(recentlyViewedUserID);
            //end  get user For Recently Viewed
            userBusinessType = user.uid.split(':')[0];
          } else {
            userBusinessType = businessType;
          }
          this.myAccountPermissionService.currentUserPermissions$.next(user?.storeFrontPermissions);
          this.myAccountPermissionService.currentUserId$.next(user?.uid);
          return this.activeBusinessType.next(userBusinessType);
        })
      )
      .subscribe();
  }

  get initBusinessType(): string {
    let result = getContextParameterDefault(this.config, 'shimanoBusinessType');
    return result;
  }
}
